import ReviewSummaryReport from './ReviewSummaryReport';

export default ReviewSummaryReport;
